import Actions      from "../../model/constant/actions"
import ReducerUtils from "../../utils/ReducerUtils"


export const InventoryFetching = ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVING_INVENTORY]           : ()=>true,
  [Actions.RETRIEVE_INVENTORY_FOR_ACCOUNT] : ()=>false
})
